import {Component} from '@angular/core';
import {Person, PersonenAngaben, Steueridentifikation} from '@nachdigal';
import {NavigationService, WizardPageBaseComponent} from '@utils-lib';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-personen-angaben',
    templateUrl: './personen-angaben.component.html'
})
export class PersonenAngabenComponent extends WizardPageBaseComponent<PersonenAngaben> {

    static nutzdatenPath = 'personenAngaben';
    static route = 'personen-angaben';

    constructor(protected readonly activatedRoute: ActivatedRoute,
                public readonly navigationService: NavigationService) {
        super(activatedRoute);
    }

    onPersonPicked($event: Person): void {
        this.data.antragsteller = $event;
        this.navigationService.onMandantNameUpdated(this.data.antragsteller.nachname, this.data.antragsteller.vorname);
    }

    public getStammdatenTemplate(): Steueridentifikation {
        if (this.stammdaten?.antragsteller?.steueridentifikation?.steueridentifikationsnummer) {
            return this.stammdaten?.antragsteller?.steueridentifikation;
        }
        return null;
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([
            ['antragsteller', this.stammdaten?.antragsteller?.person],
            ['inlandsadresse', this.stammdaten?.antragsteller?.inlandsadressen],
            ['auslandsadresse', this.stammdaten?.antragsteller?.auslandsadressen],
            ['postfachadresse', this.stammdaten?.antragsteller?.postfachadressen],
            ['kommunikationsmittel.telefonnummern[0]', this.stammdaten?.antragsteller?.kommunikation?.telefonnummern],
            ['kommunikationsmittel.internet', this.stammdaten?.antragsteller?.kommunikation?.internetadressen],
            ['steueridentifikation', this.stammdaten?.antragsteller?.steueridentifikation]
        ]);
    }

}
